import { HTMLAttributes } from 'react'
import cl from 'classnames'
import CalendarIcon from '@assets/calendar.svg'
import HouseSmileIcon from '@assets/house-smile.svg'
import LampIcon from '@assets/lamp.svg'
import LeafIcon from '@assets/leaf.svg'
import MoneyIcon from '@assets/money.svg'
import ToolsIcon from '@assets/tools.svg'

import styles from './styles.module.scss'

interface Props extends HTMLAttributes<HTMLDivElement> {
  title: string
}
export const SolarEnergy = ({ className, title }: Props) => {
  return (
    <div className={cl(styles.box, className)}>
      <div className={styles.description}>
        <h2>
          Mude a sua vida com&nbsp;
          <br />
          <span className="text-orange">{title}</span>
        </h2>
        <div className="flex flex-col gap-4">
          <div className="md:text-xl">
            Já imaginou ter em casa ou na sua empresa uma tecnologia de ponta,
            que faz sua conta de luz quase desaparecer?
          </div>
          <span className="md:text-xl">
            Gerar energia com a luz do sol é a forma mais eficiente de
            economizar e proteger o meio ambiente ao mesmo tempo.
          </span>
          <b className="md:text-xl">Venha pro Solar!</b>
        </div>
      </div>
      <ul>
        <li>
          <LeafIcon />
          Fonte de energia 100% renovável.
        </li>
        <li>
          <LampIcon />
          Redução da conta de luz em até 90%
        </li>
        <li>
          <MoneyIcon />
          Retorno do investimento entre 3 e 5 anos.
        </li>
        <li>
          <HouseSmileIcon />
          Valorização de até 30% do imóvel.
        </li>
        <li>
          <CalendarIcon />
          Vida útil de mais de 25 anos.
        </li>
        <li>
          <ToolsIcon />
          Baixa necessidade de manutenção.
        </li>
      </ul>
    </div>
  )
}
